const sortTypeLookupTable = {
  relevance: 'relevance',
  derivedpriceASC: 'price-lowest',
  derivedpriceDESC: 'price-highest',
  distanceASC: 'distance-closest',
  datelistedASC: 'date-oldest',
  datelistedDESC: 'date-newest',
  mileageASC: 'mileage-lowest',
  mileageDESC: 'mileage-highest',
  yearASC: 'year-oldest',
  yearDESC: 'year-newest',
  distanceDESC: 'distance-farthest',
  ownernameASC: 'dealership name - a-z',
  ownernameDESC: 'dealership name - z-a'
};
const getSortTypeTextHelper = sortType => sortTypeLookupTable[sortType] || sortType;
export default getSortTypeTextHelper;